function NextButton({ dispatch, answer, index, numQuestions, status }) {
    if (answer === null) return null;

    if (index < numQuestions - 1) return (
        <div>
            <button className="btn btn-right" onClick={() => dispatch({type: 'nextQuestion'})}>Next</button>
        </div>
    )

    if (index === numQuestions - 1) return (
        <div>
            <button className="btn btn-right" onClick={() => dispatch({type: 'finish'})}>Finish</button>
        </div>
    )
}

export default NextButton
